var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content", attrs: { id: "device-list" } },
    [
      _c("Titlebar", { attrs: { incrustation: "fa-exclamation-triangle" } }, [
        _c("h1", [_vm._v(_vm._s(_vm.$t("device.notifications.titles.list")))]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "fake-tabs", attrs: { role: "tab" } }, [
        _c(
          "div",
          {
            class: { active: _vm.statusFilter === false },
            on: {
              click: function ($event) {
                return _vm.setStatusFilter(false)
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("device.notifications.filters.all")))]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            class: { active: _vm.statusFilter === "planified" },
            on: {
              click: function ($event) {
                return _vm.setStatusFilter("planified")
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("device.notifications.filters.scheduled")))]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            class: { active: _vm.statusFilter === "sent" },
            on: {
              click: function ($event) {
                return _vm.setStatusFilter("sent")
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("device.notifications.filters.sent")))]
        ),
      ]),
      _vm._v(" "),
      _c(
        "UiCard",
        [
          _c("div", [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "margin-bottom": "10px",
                  "align-items": "center",
                },
              },
              [
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.activeNotificationFilter,
                        expression: "activeNotificationFilter",
                      },
                    ],
                    attrs: {
                      type: "checkbox",
                      "true-value": "1",
                      "false-value": "0",
                    },
                    domProps: {
                      checked: Array.isArray(_vm.activeNotificationFilter)
                        ? _vm._i(_vm.activeNotificationFilter, null) > -1
                        : _vm._q(_vm.activeNotificationFilter, "1"),
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.activeNotificationFilter,
                          $$el = $event.target,
                          $$c = $$el.checked ? "1" : "0"
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              (_vm.activeNotificationFilter = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.activeNotificationFilter = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.activeNotificationFilter = $$c
                        }
                      },
                    },
                  }),
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.$t("device.notifications.btns.hideReminders")
                      ) +
                      "\n                "
                  ),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("SuperTable", {
            ref: "tableNotifications",
            staticClass: "notification-table",
            attrs: {
              tableColumns: _vm.tableColumns,
              tableData: _vm.tableData,
              loading: _vm.isLoading,
            },
            on: {
              sort: _vm.handleSort,
              filter: _vm.handleFilter,
              delete: _vm.handleDelete,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("Toolbar", [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col" },
            [
              _c(
                "Btn",
                { class: "default" },
                [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: "/parameters/notifications/new",
                        tag: "span",
                      },
                    },
                    [
                      _c("i", { staticClass: "fa fa-plus" }),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("device.notifications.btns.new"))),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col center" },
            [
              _c("Pagination", {
                ref: "pagination",
                on: { change: _vm.handlePagination },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col" }),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }